import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { MemberLearningPlanStats } from "@modules/organisation-workspaces/models/member-learning-plan-stats.model";

export interface OrganisationMemberListItem {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  communicationEmail: string;
  admin?: boolean;
  manager?: boolean;
  auditor?:boolean;
  image: string;
  profileId: string;
  organisationProfileId: string;
  verificationCode:string;
  verified?:boolean;
  functions:string;
  memberType?:'member'|'employee'|'ex-employee'|'non-employee'|'futur-employee'|'paternity_leave_full_time'|'paternity_leave_part_time';
  stats?:MemberLearningPlanStats[];
  hasActiveUser:boolean;

}


@Injectable({
  providedIn: 'root'
})

export class OrganisationMemberListItemAdapter implements Adapter<OrganisationMemberListItem> {
  constructor() {}

  adapt(item: any): OrganisationMemberListItem {
    
    const userProfile = item.userProfile;

    return {
      id: item.id,
      firstName: (userProfile.firstName || "").trim(),
      lastName: (userProfile.lastName || "").trim(),
      email: userProfile.emailAddress || "",
      admin: item.isAdmin ?? false,
      manager: item.isManager ?? false,
      auditor: item.isAuditor??false,
      image: "",
      profileId: userProfile.id || "",
      communicationEmail: userProfile.communicationEmailAddress || "",
      organisationProfileId: item.organisationProfile.id || "",
      memberType:item.status,
      verificationCode: item.verificationCode??'',
      verified:item.userVerified??false,
      functions: (item.allFunctions??[]).join(', ') ??'',
      hasActiveUser: item.active??false
    }
  }
}
